export const houseTranslations = {
  "Casinha de madeira": {
    name: {
      en: "Wooden Cottage",
      es: "Casita de Madera",
      zh: "木制小屋"
    },
    description: {
      en: "For humble fishermen",
      es: "Para pescadores más humildes",
      zh: "适合谦逊的渔民"
    }
  },
  "Casa arrumadinha": {
    name: {
      en: "Tidy House",
      es: "Casa Ordenada",
      zh: "整洁小屋"
    },
    description: {
      en: "A simple but well-kept house",
      es: "Una casa simple pero bien ordenada",
      zh: "简单但整洁的房子"
    }
  },
  "Vila dos pescadores": {
    name: {
      en: "Fishermen's Village",
      es: "Pueblo de Pescadores",
      zh: "渔民村"
    },
    description: {
      en: "A brick house in the village",
      es: "Una casa de albañilería en el pueblo",
      zh: "村里的砖房"
    }
  },
  "Hotel Belas Flores": {
    name: {
      en: "Beautiful Flowers Hotel",
      es: "Hotel Bellas Flores",
      zh: "美丽花园酒店"
    },
    description: {
      en: "Buy this classic city hotel",
      es: "Compre este hotel clásico de la ciudad",
      zh: "购买这家经典的城市酒店"
    }
  },
  "Casa no penhasco": {
    name: {
      en: "Cliff House",
      es: "Casa del Acantilado",
      zh: "悬崖别墅"
    },
    description: {
      en: "The most beautiful view in the village",
      es: "La vista más hermosa de todo el pueblo",
      zh: "全村最美的景色"
    }
  },
  "Mansão Magnata do Peixe": {
    name: {
      en: "Fish Tycoon Mansion",
      es: "Mansión del Magnate Pesquero",
      zh: "渔业大亨豪宅"
    },
    description: {
      en: "The mansion for the richest fishermen in the village",
      es: "La mansión para los pescadores más ricos del pueblo",
      zh: "村里最富有渔民的豪宅"
    }
  }
};
